// 研究领域
export const field = [
  'Accounting',
  'Actuarial',
  'Aerospace Engineering',
  'Animation',
  'Anthropology',
  'Architecture',
  'Asian Studies/Other Area Studies',
  'Biological Engineering',
  'Biology',
  'Biomedical Engineering',
  'Business',
  'Business Analytics',
  'Chemical Engineering',
  'Chemistry',
  'Civil Engineering',
  'Communication/Media/Journalism',
  'Computer Science',
  'Data Science',
  'Development Studies',
  'Economics',
  'Education',
  'Electrical and Computer Engineering',
  'Energy / Petroleum',
  'Environmental Engineering',
  'Environmental',
  'Filmmaking-related',
  'Finance',
  'Financial Economics',
  'Financial Engineering/Mathematical Finance/Quantitative Finance',
  'Food Science',
  'Geography',
  'Geophyscis',
  'History',
  'HR Management',
  'Human Computer interaction',
  'Industrial Engineering & Operational Research',
  'Languages',
  'Law',
  'Literature',
  'Management (non-MBA)',
  'Management Information System',
  'Management Science & Engineering',
  'Marketing',
  'Material Science and Engineering',
  'Mathematics',
  'MBA',
  'Mechanical Engineering',
  'Medicine relate',
  'Medicine',
  'Music-related',
  'Other Art and Design Field',
  'Other Business Field',
  'Other Engineering Field',
  'Other Health Field',
  'Other Humanities Field',
  'Other Science Field',
  'Other Social Sciences Field',
  'Other',
  'Pharmacy',
  'Philosophy',
  'Physics',
  'Politics/International Relations',
  'Psychology',
  'Public Administration/Policy',
  'Public Health',
  'Real Estate',
  'Religion',
  'Social Work/Sociology',
  'Sports',
  'Statistics',
  'Transportation',
  'Urban Planning'
]
// 时区
export const zone = [
  {
    value: 'AEST',
    title: 'Australian Eastern Standard Time'
  },
  {
    value: 'ACST',
    title: 'Australian Central Standard Time'
  },
  {
    value: 'AWST',
    title: 'Australian Central Western Standard Time'
  },
  {
    value: 'BJT',
    title: 'Beijing Time'
  },
  {
    value: 'EST',
    title: 'US Eastern Time'
  },
  {
    value: 'MST',
    title: 'US Mountain Time'
  },
  {
    value: 'CST',
    title: 'US Central Time'
  },
  {
    value: 'PST',
    title: 'US Pacific Time'
  },
  {
    value: 'SAST',
    title: 'South Africa Time'
  },
  {
    value: 'BST',
    title: 'British Time'
  },
  {
    value: 'FST',
    title: 'French Time'
  }
]
// 程度
export const degree = [
  {
    value: 'PHD',
    title: 'PhD'
  },
  {
    value: 'MASTER',
    title: 'Master'
  },
  {
    value: 'DPHILL',
    title: 'DPhill'
  },
  {
    value: 'MPHILL',
    title: 'MPhill'
  },
  {
    value: 'MSC',
    title: 'MSc'
  },
  {
    value: 'MSA',
    title: 'MSa'
  },
  {
    value: 'JD',
    title: 'JD'
  },
  {
    value: 'MD',
    title: 'MD'
  },
  {
    value: 'OTHER',
    title: 'Other'
  },
  {
    value: 'BACHELOR_DEGREE',
    title: 'Bachelor Degree'
  },
  {
    value: 'INTEND_BACHELOR_DEGREE',
    title: 'In progress of pursuing Bachelor degree'
  }
]
// 推荐来源
export const referrerSource = [
  {
    value: 'FORMERZLRMENTEE',
    title: 'Former ZLR Mentee'
  },
  {
    value: 'ZLRMENTORRECOMMENDATION',
    title: 'ZLR Mentor recommendation'
  },
  {
    value: 'ZLREMPLOYEERECOMMENDATION',
    title: 'ZlR employee recommendation'
  },
  {
    value: 'WECHATARTICLE',
    title: 'WeChat Article'
  },
  {
    value: 'OTHERS',
    title: 'Others'
  }
]
// 职业
export const occupation = [
  {
    value: 'POSTANDBEYOND',
    title: 'Post-doc & beyond'
  },
  {
    value: 'PHDSTUDENT',
    title: 'PhD student'
  },
  {
    value: 'GRADUATE',
    title: 'Graduate student'
  },
  {
    value: 'UNGRADUATE',
    title: 'Undergraduate student'
  },
  {
    value: 'EMPLOYED',
    title: 'Employed'
  },
  {
    value: 'UNEMPLOYED',
    title: 'Unemployed'
  },
  {
    value: 'OTHER',
    title: 'Other'
  }
]
